/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as OrgIndexRouteImport } from './routes/$org/index'
import { Route as OrgAgentRouteImport } from './routes/$org/$agent'
import { Route as OrgAgentIndexRouteImport } from './routes/$org/$agent/index'
import { Route as OrgAgentTrendsRouteImport } from './routes/$org/$agent/trends'
import { Route as OrgAgentSensorCalibrationRouteImport } from './routes/$org/$agent/sensor-calibration'
import { Route as OrgAgentReportsRouteImport } from './routes/$org/$agent/reports'
import { Route as OrgAgentProcessViewRouteImport } from './routes/$org/$agent/process-view'
import { Route as OrgAgentPredictiveDryingControlRouteImport } from './routes/$org/$agent/predictive-drying-control'
import { Route as OrgAgentNetkitRouteImport } from './routes/$org/$agent/netkit'
import { Route as OrgAgentMapRouteImport } from './routes/$org/$agent/map'
import { Route as OrgAgentFacilityPerformanceRouteImport } from './routes/$org/$agent/facility-performance'
import { Route as OrgAgentEquipmentRouteImport } from './routes/$org/$agent/equipment'
import { Route as OrgAgentDemandResponseEventsRouteImport } from './routes/$org/$agent/demand-response-events'
import { Route as OrgAgentDemandResponseAdminRouteImport } from './routes/$org/$agent/demand-response-admin'
import { Route as OrgAgentDemandEventsRouteImport } from './routes/$org/$agent/demand-events'
import { Route as OrgAgentCoincidentPeaksRouteImport } from './routes/$org/$agent/coincident-peaks'
import { Route as OrgAgentAlarmsRouteImport } from './routes/$org/$agent/alarms'
import { Route as OrgAgentSplatRouteImport } from './routes/$org/$agent/$'

const UxdsLazyRouteImport = createFileRoute('/uxds')()
const LearningLazyRouteImport = createFileRoute('/learning')()
const ErrorLazyRouteImport = createFileRoute('/error')()
const IndexLazyRouteImport = createFileRoute('/')()

const UxdsLazyRoute = UxdsLazyRouteImport.update({
  id: '/uxds',
  path: '/uxds',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/uxds.lazy').then((d) => d.Route))
const LearningLazyRoute = LearningLazyRouteImport.update({
  id: '/learning',
  path: '/learning',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/learning.lazy').then((d) => d.Route))
const ErrorLazyRoute = ErrorLazyRouteImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/error.lazy').then((d) => d.Route))
const IndexLazyRoute = IndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))
const OrgIndexRoute = OrgIndexRouteImport.update({
  id: '/$org/',
  path: '/$org/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgAgentRoute = OrgAgentRouteImport.update({
  id: '/$org/$agent',
  path: '/$org/$agent',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgAgentIndexRoute = OrgAgentIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OrgAgentRoute,
} as any).lazy(() =>
  import('./routes/$org/$agent/index.lazy').then((d) => d.Route),
)
const OrgAgentTrendsRoute = OrgAgentTrendsRouteImport.update({
  id: '/trends',
  path: '/trends',
  getParentRoute: () => OrgAgentRoute,
} as any).lazy(() =>
  import('./routes/$org/$agent/trends.lazy').then((d) => d.Route),
)
const OrgAgentSensorCalibrationRoute =
  OrgAgentSensorCalibrationRouteImport.update({
    id: '/sensor-calibration',
    path: '/sensor-calibration',
    getParentRoute: () => OrgAgentRoute,
  } as any).lazy(() =>
    import('./routes/$org/$agent/sensor-calibration.lazy').then((d) => d.Route),
  )
const OrgAgentReportsRoute = OrgAgentReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => OrgAgentRoute,
} as any).lazy(() =>
  import('./routes/$org/$agent/reports.lazy').then((d) => d.Route),
)
const OrgAgentProcessViewRoute = OrgAgentProcessViewRouteImport.update({
  id: '/process-view',
  path: '/process-view',
  getParentRoute: () => OrgAgentRoute,
} as any).lazy(() =>
  import('./routes/$org/$agent/process-view.lazy').then((d) => d.Route),
)
const OrgAgentPredictiveDryingControlRoute =
  OrgAgentPredictiveDryingControlRouteImport.update({
    id: '/predictive-drying-control',
    path: '/predictive-drying-control',
    getParentRoute: () => OrgAgentRoute,
  } as any).lazy(() =>
    import('./routes/$org/$agent/predictive-drying-control.lazy').then(
      (d) => d.Route,
    ),
  )
const OrgAgentNetkitRoute = OrgAgentNetkitRouteImport.update({
  id: '/netkit',
  path: '/netkit',
  getParentRoute: () => OrgAgentRoute,
} as any).lazy(() =>
  import('./routes/$org/$agent/netkit.lazy').then((d) => d.Route),
)
const OrgAgentMapRoute = OrgAgentMapRouteImport.update({
  id: '/map',
  path: '/map',
  getParentRoute: () => OrgAgentRoute,
} as any).lazy(() =>
  import('./routes/$org/$agent/map.lazy').then((d) => d.Route),
)
const OrgAgentFacilityPerformanceRoute =
  OrgAgentFacilityPerformanceRouteImport.update({
    id: '/facility-performance',
    path: '/facility-performance',
    getParentRoute: () => OrgAgentRoute,
  } as any).lazy(() =>
    import('./routes/$org/$agent/facility-performance.lazy').then(
      (d) => d.Route,
    ),
  )
const OrgAgentEquipmentRoute = OrgAgentEquipmentRouteImport.update({
  id: '/equipment',
  path: '/equipment',
  getParentRoute: () => OrgAgentRoute,
} as any).lazy(() =>
  import('./routes/$org/$agent/equipment.lazy').then((d) => d.Route),
)
const OrgAgentDemandResponseEventsRoute =
  OrgAgentDemandResponseEventsRouteImport.update({
    id: '/demand-response-events',
    path: '/demand-response-events',
    getParentRoute: () => OrgAgentRoute,
  } as any).lazy(() =>
    import('./routes/$org/$agent/demand-response-events.lazy').then(
      (d) => d.Route,
    ),
  )
const OrgAgentDemandResponseAdminRoute =
  OrgAgentDemandResponseAdminRouteImport.update({
    id: '/demand-response-admin',
    path: '/demand-response-admin',
    getParentRoute: () => OrgAgentRoute,
  } as any).lazy(() =>
    import('./routes/$org/$agent/demand-response-admin.lazy').then(
      (d) => d.Route,
    ),
  )
const OrgAgentDemandEventsRoute = OrgAgentDemandEventsRouteImport.update({
  id: '/demand-events',
  path: '/demand-events',
  getParentRoute: () => OrgAgentRoute,
} as any).lazy(() =>
  import('./routes/$org/$agent/demand-events.lazy').then((d) => d.Route),
)
const OrgAgentCoincidentPeaksRoute = OrgAgentCoincidentPeaksRouteImport.update({
  id: '/coincident-peaks',
  path: '/coincident-peaks',
  getParentRoute: () => OrgAgentRoute,
} as any).lazy(() =>
  import('./routes/$org/$agent/coincident-peaks.lazy').then((d) => d.Route),
)
const OrgAgentAlarmsRoute = OrgAgentAlarmsRouteImport.update({
  id: '/alarms',
  path: '/alarms',
  getParentRoute: () => OrgAgentRoute,
} as any).lazy(() =>
  import('./routes/$org/$agent/alarms.lazy').then((d) => d.Route),
)
const OrgAgentSplatRoute = OrgAgentSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => OrgAgentRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexLazyRoute
  '/error': typeof ErrorLazyRoute
  '/learning': typeof LearningLazyRoute
  '/uxds': typeof UxdsLazyRoute
  '/$org/$agent': typeof OrgAgentRouteWithChildren
  '/$org/': typeof OrgIndexRoute
  '/$org/$agent/$': typeof OrgAgentSplatRoute
  '/$org/$agent/alarms': typeof OrgAgentAlarmsRoute
  '/$org/$agent/coincident-peaks': typeof OrgAgentCoincidentPeaksRoute
  '/$org/$agent/demand-events': typeof OrgAgentDemandEventsRoute
  '/$org/$agent/demand-response-admin': typeof OrgAgentDemandResponseAdminRoute
  '/$org/$agent/demand-response-events': typeof OrgAgentDemandResponseEventsRoute
  '/$org/$agent/equipment': typeof OrgAgentEquipmentRoute
  '/$org/$agent/facility-performance': typeof OrgAgentFacilityPerformanceRoute
  '/$org/$agent/map': typeof OrgAgentMapRoute
  '/$org/$agent/netkit': typeof OrgAgentNetkitRoute
  '/$org/$agent/predictive-drying-control': typeof OrgAgentPredictiveDryingControlRoute
  '/$org/$agent/process-view': typeof OrgAgentProcessViewRoute
  '/$org/$agent/reports': typeof OrgAgentReportsRoute
  '/$org/$agent/sensor-calibration': typeof OrgAgentSensorCalibrationRoute
  '/$org/$agent/trends': typeof OrgAgentTrendsRoute
  '/$org/$agent/': typeof OrgAgentIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexLazyRoute
  '/error': typeof ErrorLazyRoute
  '/learning': typeof LearningLazyRoute
  '/uxds': typeof UxdsLazyRoute
  '/$org': typeof OrgIndexRoute
  '/$org/$agent/$': typeof OrgAgentSplatRoute
  '/$org/$agent/alarms': typeof OrgAgentAlarmsRoute
  '/$org/$agent/coincident-peaks': typeof OrgAgentCoincidentPeaksRoute
  '/$org/$agent/demand-events': typeof OrgAgentDemandEventsRoute
  '/$org/$agent/demand-response-admin': typeof OrgAgentDemandResponseAdminRoute
  '/$org/$agent/demand-response-events': typeof OrgAgentDemandResponseEventsRoute
  '/$org/$agent/equipment': typeof OrgAgentEquipmentRoute
  '/$org/$agent/facility-performance': typeof OrgAgentFacilityPerformanceRoute
  '/$org/$agent/map': typeof OrgAgentMapRoute
  '/$org/$agent/netkit': typeof OrgAgentNetkitRoute
  '/$org/$agent/predictive-drying-control': typeof OrgAgentPredictiveDryingControlRoute
  '/$org/$agent/process-view': typeof OrgAgentProcessViewRoute
  '/$org/$agent/reports': typeof OrgAgentReportsRoute
  '/$org/$agent/sensor-calibration': typeof OrgAgentSensorCalibrationRoute
  '/$org/$agent/trends': typeof OrgAgentTrendsRoute
  '/$org/$agent': typeof OrgAgentIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexLazyRoute
  '/error': typeof ErrorLazyRoute
  '/learning': typeof LearningLazyRoute
  '/uxds': typeof UxdsLazyRoute
  '/$org/$agent': typeof OrgAgentRouteWithChildren
  '/$org/': typeof OrgIndexRoute
  '/$org/$agent/$': typeof OrgAgentSplatRoute
  '/$org/$agent/alarms': typeof OrgAgentAlarmsRoute
  '/$org/$agent/coincident-peaks': typeof OrgAgentCoincidentPeaksRoute
  '/$org/$agent/demand-events': typeof OrgAgentDemandEventsRoute
  '/$org/$agent/demand-response-admin': typeof OrgAgentDemandResponseAdminRoute
  '/$org/$agent/demand-response-events': typeof OrgAgentDemandResponseEventsRoute
  '/$org/$agent/equipment': typeof OrgAgentEquipmentRoute
  '/$org/$agent/facility-performance': typeof OrgAgentFacilityPerformanceRoute
  '/$org/$agent/map': typeof OrgAgentMapRoute
  '/$org/$agent/netkit': typeof OrgAgentNetkitRoute
  '/$org/$agent/predictive-drying-control': typeof OrgAgentPredictiveDryingControlRoute
  '/$org/$agent/process-view': typeof OrgAgentProcessViewRoute
  '/$org/$agent/reports': typeof OrgAgentReportsRoute
  '/$org/$agent/sensor-calibration': typeof OrgAgentSensorCalibrationRoute
  '/$org/$agent/trends': typeof OrgAgentTrendsRoute
  '/$org/$agent/': typeof OrgAgentIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/error'
    | '/learning'
    | '/uxds'
    | '/$org/$agent'
    | '/$org/'
    | '/$org/$agent/$'
    | '/$org/$agent/alarms'
    | '/$org/$agent/coincident-peaks'
    | '/$org/$agent/demand-events'
    | '/$org/$agent/demand-response-admin'
    | '/$org/$agent/demand-response-events'
    | '/$org/$agent/equipment'
    | '/$org/$agent/facility-performance'
    | '/$org/$agent/map'
    | '/$org/$agent/netkit'
    | '/$org/$agent/predictive-drying-control'
    | '/$org/$agent/process-view'
    | '/$org/$agent/reports'
    | '/$org/$agent/sensor-calibration'
    | '/$org/$agent/trends'
    | '/$org/$agent/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/error'
    | '/learning'
    | '/uxds'
    | '/$org'
    | '/$org/$agent/$'
    | '/$org/$agent/alarms'
    | '/$org/$agent/coincident-peaks'
    | '/$org/$agent/demand-events'
    | '/$org/$agent/demand-response-admin'
    | '/$org/$agent/demand-response-events'
    | '/$org/$agent/equipment'
    | '/$org/$agent/facility-performance'
    | '/$org/$agent/map'
    | '/$org/$agent/netkit'
    | '/$org/$agent/predictive-drying-control'
    | '/$org/$agent/process-view'
    | '/$org/$agent/reports'
    | '/$org/$agent/sensor-calibration'
    | '/$org/$agent/trends'
    | '/$org/$agent'
  id:
    | '__root__'
    | '/'
    | '/error'
    | '/learning'
    | '/uxds'
    | '/$org/$agent'
    | '/$org/'
    | '/$org/$agent/$'
    | '/$org/$agent/alarms'
    | '/$org/$agent/coincident-peaks'
    | '/$org/$agent/demand-events'
    | '/$org/$agent/demand-response-admin'
    | '/$org/$agent/demand-response-events'
    | '/$org/$agent/equipment'
    | '/$org/$agent/facility-performance'
    | '/$org/$agent/map'
    | '/$org/$agent/netkit'
    | '/$org/$agent/predictive-drying-control'
    | '/$org/$agent/process-view'
    | '/$org/$agent/reports'
    | '/$org/$agent/sensor-calibration'
    | '/$org/$agent/trends'
    | '/$org/$agent/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexLazyRoute: typeof IndexLazyRoute
  ErrorLazyRoute: typeof ErrorLazyRoute
  LearningLazyRoute: typeof LearningLazyRoute
  UxdsLazyRoute: typeof UxdsLazyRoute
  OrgAgentRoute: typeof OrgAgentRouteWithChildren
  OrgIndexRoute: typeof OrgIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/uxds': {
      id: '/uxds'
      path: '/uxds'
      fullPath: '/uxds'
      preLoaderRoute: typeof UxdsLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/learning': {
      id: '/learning'
      path: '/learning'
      fullPath: '/learning'
      preLoaderRoute: typeof LearningLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/error': {
      id: '/error'
      path: '/error'
      fullPath: '/error'
      preLoaderRoute: typeof ErrorLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$org/': {
      id: '/$org/'
      path: '/$org'
      fullPath: '/$org/'
      preLoaderRoute: typeof OrgIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$org/$agent': {
      id: '/$org/$agent'
      path: '/$org/$agent'
      fullPath: '/$org/$agent'
      preLoaderRoute: typeof OrgAgentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$org/$agent/': {
      id: '/$org/$agent/'
      path: '/'
      fullPath: '/$org/$agent/'
      preLoaderRoute: typeof OrgAgentIndexRouteImport
      parentRoute: typeof OrgAgentRoute
    }
    '/$org/$agent/trends': {
      id: '/$org/$agent/trends'
      path: '/trends'
      fullPath: '/$org/$agent/trends'
      preLoaderRoute: typeof OrgAgentTrendsRouteImport
      parentRoute: typeof OrgAgentRoute
    }
    '/$org/$agent/sensor-calibration': {
      id: '/$org/$agent/sensor-calibration'
      path: '/sensor-calibration'
      fullPath: '/$org/$agent/sensor-calibration'
      preLoaderRoute: typeof OrgAgentSensorCalibrationRouteImport
      parentRoute: typeof OrgAgentRoute
    }
    '/$org/$agent/reports': {
      id: '/$org/$agent/reports'
      path: '/reports'
      fullPath: '/$org/$agent/reports'
      preLoaderRoute: typeof OrgAgentReportsRouteImport
      parentRoute: typeof OrgAgentRoute
    }
    '/$org/$agent/process-view': {
      id: '/$org/$agent/process-view'
      path: '/process-view'
      fullPath: '/$org/$agent/process-view'
      preLoaderRoute: typeof OrgAgentProcessViewRouteImport
      parentRoute: typeof OrgAgentRoute
    }
    '/$org/$agent/predictive-drying-control': {
      id: '/$org/$agent/predictive-drying-control'
      path: '/predictive-drying-control'
      fullPath: '/$org/$agent/predictive-drying-control'
      preLoaderRoute: typeof OrgAgentPredictiveDryingControlRouteImport
      parentRoute: typeof OrgAgentRoute
    }
    '/$org/$agent/netkit': {
      id: '/$org/$agent/netkit'
      path: '/netkit'
      fullPath: '/$org/$agent/netkit'
      preLoaderRoute: typeof OrgAgentNetkitRouteImport
      parentRoute: typeof OrgAgentRoute
    }
    '/$org/$agent/map': {
      id: '/$org/$agent/map'
      path: '/map'
      fullPath: '/$org/$agent/map'
      preLoaderRoute: typeof OrgAgentMapRouteImport
      parentRoute: typeof OrgAgentRoute
    }
    '/$org/$agent/facility-performance': {
      id: '/$org/$agent/facility-performance'
      path: '/facility-performance'
      fullPath: '/$org/$agent/facility-performance'
      preLoaderRoute: typeof OrgAgentFacilityPerformanceRouteImport
      parentRoute: typeof OrgAgentRoute
    }
    '/$org/$agent/equipment': {
      id: '/$org/$agent/equipment'
      path: '/equipment'
      fullPath: '/$org/$agent/equipment'
      preLoaderRoute: typeof OrgAgentEquipmentRouteImport
      parentRoute: typeof OrgAgentRoute
    }
    '/$org/$agent/demand-response-events': {
      id: '/$org/$agent/demand-response-events'
      path: '/demand-response-events'
      fullPath: '/$org/$agent/demand-response-events'
      preLoaderRoute: typeof OrgAgentDemandResponseEventsRouteImport
      parentRoute: typeof OrgAgentRoute
    }
    '/$org/$agent/demand-response-admin': {
      id: '/$org/$agent/demand-response-admin'
      path: '/demand-response-admin'
      fullPath: '/$org/$agent/demand-response-admin'
      preLoaderRoute: typeof OrgAgentDemandResponseAdminRouteImport
      parentRoute: typeof OrgAgentRoute
    }
    '/$org/$agent/demand-events': {
      id: '/$org/$agent/demand-events'
      path: '/demand-events'
      fullPath: '/$org/$agent/demand-events'
      preLoaderRoute: typeof OrgAgentDemandEventsRouteImport
      parentRoute: typeof OrgAgentRoute
    }
    '/$org/$agent/coincident-peaks': {
      id: '/$org/$agent/coincident-peaks'
      path: '/coincident-peaks'
      fullPath: '/$org/$agent/coincident-peaks'
      preLoaderRoute: typeof OrgAgentCoincidentPeaksRouteImport
      parentRoute: typeof OrgAgentRoute
    }
    '/$org/$agent/alarms': {
      id: '/$org/$agent/alarms'
      path: '/alarms'
      fullPath: '/$org/$agent/alarms'
      preLoaderRoute: typeof OrgAgentAlarmsRouteImport
      parentRoute: typeof OrgAgentRoute
    }
    '/$org/$agent/$': {
      id: '/$org/$agent/$'
      path: '/$'
      fullPath: '/$org/$agent/$'
      preLoaderRoute: typeof OrgAgentSplatRouteImport
      parentRoute: typeof OrgAgentRoute
    }
  }
}

interface OrgAgentRouteChildren {
  OrgAgentSplatRoute: typeof OrgAgentSplatRoute
  OrgAgentAlarmsRoute: typeof OrgAgentAlarmsRoute
  OrgAgentCoincidentPeaksRoute: typeof OrgAgentCoincidentPeaksRoute
  OrgAgentDemandEventsRoute: typeof OrgAgentDemandEventsRoute
  OrgAgentDemandResponseAdminRoute: typeof OrgAgentDemandResponseAdminRoute
  OrgAgentDemandResponseEventsRoute: typeof OrgAgentDemandResponseEventsRoute
  OrgAgentEquipmentRoute: typeof OrgAgentEquipmentRoute
  OrgAgentFacilityPerformanceRoute: typeof OrgAgentFacilityPerformanceRoute
  OrgAgentMapRoute: typeof OrgAgentMapRoute
  OrgAgentNetkitRoute: typeof OrgAgentNetkitRoute
  OrgAgentPredictiveDryingControlRoute: typeof OrgAgentPredictiveDryingControlRoute
  OrgAgentProcessViewRoute: typeof OrgAgentProcessViewRoute
  OrgAgentReportsRoute: typeof OrgAgentReportsRoute
  OrgAgentSensorCalibrationRoute: typeof OrgAgentSensorCalibrationRoute
  OrgAgentTrendsRoute: typeof OrgAgentTrendsRoute
  OrgAgentIndexRoute: typeof OrgAgentIndexRoute
}

const OrgAgentRouteChildren: OrgAgentRouteChildren = {
  OrgAgentSplatRoute: OrgAgentSplatRoute,
  OrgAgentAlarmsRoute: OrgAgentAlarmsRoute,
  OrgAgentCoincidentPeaksRoute: OrgAgentCoincidentPeaksRoute,
  OrgAgentDemandEventsRoute: OrgAgentDemandEventsRoute,
  OrgAgentDemandResponseAdminRoute: OrgAgentDemandResponseAdminRoute,
  OrgAgentDemandResponseEventsRoute: OrgAgentDemandResponseEventsRoute,
  OrgAgentEquipmentRoute: OrgAgentEquipmentRoute,
  OrgAgentFacilityPerformanceRoute: OrgAgentFacilityPerformanceRoute,
  OrgAgentMapRoute: OrgAgentMapRoute,
  OrgAgentNetkitRoute: OrgAgentNetkitRoute,
  OrgAgentPredictiveDryingControlRoute: OrgAgentPredictiveDryingControlRoute,
  OrgAgentProcessViewRoute: OrgAgentProcessViewRoute,
  OrgAgentReportsRoute: OrgAgentReportsRoute,
  OrgAgentSensorCalibrationRoute: OrgAgentSensorCalibrationRoute,
  OrgAgentTrendsRoute: OrgAgentTrendsRoute,
  OrgAgentIndexRoute: OrgAgentIndexRoute,
}

const OrgAgentRouteWithChildren = OrgAgentRoute._addFileChildren(
  OrgAgentRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexLazyRoute: IndexLazyRoute,
  ErrorLazyRoute: ErrorLazyRoute,
  LearningLazyRoute: LearningLazyRoute,
  UxdsLazyRoute: UxdsLazyRoute,
  OrgAgentRoute: OrgAgentRouteWithChildren,
  OrgIndexRoute: OrgIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
